export default async function ensureMessagingServiceWorker() {
    if (!('serviceWorker' in navigator)) {
        return null;
    }
    try {
        if (__DEV__) {
            await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        }
        return await navigator.serviceWorker.ready;
    }
    catch (error) {
        console.warn('Failed to ensure messaging service worker:', error);
        return null;
    }
}
